module.exports = __webpack_public_path__ + "static/media/conversation.1ce9b0ed.png";